import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';
import {
  ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_QUERY,
  UPDATE_ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_MUTATION,
} from '../../services/dashboard.service';
import { Dialog } from 'primereact/dialog';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import DataDifferentFromCountAccountOrganisationSizeNotification from './DataDifferentFromCountAccountOrganisationSizeNotification';

const DEFAULT_STATE = {
  id: null,
};

const AccountOrganisationSizeNotification = () => {
  const [notification, setNotification] = useState(DEFAULT_STATE);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const history = useHistory();

  const { data } = useQuery(ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'network-only',
  });
  const [updateAccountOrganisationSizeNotification] = useMutation(
    UPDATE_ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_MUTATION,
  );

  useEffect(() => {
    if (data && data.accountOrganisationSizeNotification) {
      setNotification(data.accountOrganisationSizeNotification);
    }
  }, [data]);

  const hide = () => setNotification(DEFAULT_STATE);
  const redirect = () =>
    history.push(`/accounts/${currentAccount}/settings?editCompanyData=true&focusOrganisationSize=true`);

  const updateNotification = async (callback) => {
    try {
      await updateAccountOrganisationSizeNotification({
        variables: {
          input: {
            notificationId: notification.id,
            accountId: currentAccount,
          },
        },
      });

      callback();
    } catch (error) {
      growlErrors(growl, error);
    }
  };

  return (
    <Dialog
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={notification !== DEFAULT_STATE}
      onHide={() => {}}
      position="center"
      header="You have many Internal Respondents - perhaps too many?"
    >
      <DataDifferentFromCountAccountOrganisationSizeNotification
        updateNotification={() => updateNotification(hide)}
        updateNotificationWithRedirect={() => updateNotification(redirect)}
      />
    </Dialog>
  );
};

export default AccountOrganisationSizeNotification;
